var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrawerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1761 4.15988L5.72193 8.61409C5.619 8.71701 5.5625 8.85425 5.5625 9.00376C5.5625 9.15026 5.619 9.28758 5.72193 9.39034L10.1718 13.8404C10.2748 13.9433 10.4122 14 10.5587 14C10.7052 14 10.8426 13.9434 10.9455 13.8404L11.2732 13.5127C11.3761 13.4098 11.433 13.2724 11.433 13.1259C11.433 12.9794 11.3761 12.842 11.2732 12.739L7.53639 9.00222L11.2775 5.26126C11.3804 5.15833 11.4371 5.02101 11.4371 4.87443C11.4371 4.72792 11.3804 4.59069 11.2775 4.48768L10.9496 4.15988C10.7364 3.94671 10.3893 3.94671 10.1761 4.15988Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawerIcon);
export default __webpack_public_path__ + "static/media/drawerIcon.c53bfb22b950de6fbbd5c27b95a9d4ca.svg";
export { ForwardRef as ReactComponent };